
import { Route } from "react-router-dom";
import MenuCreacion from "./MenuCreacion";
import { getFacilitador } from "../index";
import Crear from "./Crear";
import EditarPanel from "./Editar";
import ShortProvider from "../../../../Panel/Context/Shorts";
import LandingProvider from "./Context";
import { Ver } from "./Ver";
import { getKeyFacilitador } from "./Keys/Facilitador";
export default function LandingFacilitador() {
    const c = getFacilitador();
    const f = getKeyFacilitador(c).getKeys();
    return <ShortProvider lista={f}><LandingProvider>
        <Route path={`/facilitador/landing/${c.id}`} exact><Ver /></Route>
        <Route path={`/facilitador/landing/${c.id}/crear`} exact><MenuCreacion /></Route>
        <Route path={`/facilitador/landing/${c.id}/crear/:type`}><Crear /></Route>
        <Route path={`/facilitador/landing/${c.id}/edit/:mid`}><EditarPanel /></Route>
    </LandingProvider></ShortProvider >
}